export const DOMAIN_NAME = "PSOS Technologies";

